import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class Collapse {
	static init() {
		const collapseContainers = document.querySelectorAll(".collapses");
		this.collapses = [];
		collapseContainers.forEach(container => {
			const collapses = container.querySelectorAll(".collapse");
			collapses.forEach(collapse => {
				collapse.head = collapse.querySelector(".collapse-head");
				collapse.body = collapse.querySelector(".collapse-body");

				collapse.body.dataset.height = collapse.body.clientHeight;
				collapse.body.style.height = 0;

				collapse.addEventListener("click", () => {
					collapses.forEach(item => {
						if (item !== collapse || collapse.classList.contains("open")) {
							item.classList.remove("open");
							gsap.to(item.body, {
								height: 0,
								duration: 0.3
							});
						} else {
							item.classList.add("open");
							gsap.to(item.body, {
								height: item.body.dataset.height,
								duration: 0.3
							});
						}
					});
				});

				this.collapses.push(collapse);
			});
		});
		GlobalVariables.resizeCallbacks.push(this);
	}

	static resize() {
		this.collapses.forEach(collapse => {
			const body = collapse.querySelector(".collapse-body");
			body.style.height = "auto";
			body.dataset.height = body.clientHeight;
			if (!collapse.classList.contains("open")) {
				body.style.height = 0;
			}
		});
	}
}
